module.exports = __webpack_public_path__ + "static/img/s36.93ad396c.png";